import styled from 'styled-components';

export const PageNotFoundWrapper = styled.div`
  display: flex;
  height: 100%;
`;
